import { useNavigationPaneContext } from '@website-editor/context/NavigationPaneContext/NavigationPane.context';
import { useEffect } from 'react';
import { JsonComponentSwitchProps } from '../JsonComponentSwitch';
import { getJsonComponentNavigations } from '../JsonComponent.navigations';
import { JSON_COMPONENT_ANIMATION_CONFIG, JSON_COMPONENT_SCREENS } from '../JsonComponent.constants';
/**
 * Add jsonComponent left panel navigation animation configs
 */
export const useAddCustomJsonComponentNavigations = (props: JsonComponentSwitchProps) => {
  const { screens, addNavigations } = useNavigationPaneContext();
  const jsonComponentNavigations = getJsonComponentNavigations({ ...props });
  useEffect(() => {
    if (!screens.includes(JSON_COMPONENT_SCREENS[0])) {
      addNavigations(JSON_COMPONENT_SCREENS, JSON_COMPONENT_ANIMATION_CONFIG, jsonComponentNavigations);
    }
  }, [addNavigations, screens, jsonComponentNavigations]);
};
